export default "__VITE_ASSET__4b9f8eec__"